<fgb-page-header [pageTitle]="'nav.account'" [showBalance]="true" [backButtonLink]="'/'"></fgb-page-header>

<div class="pt-lg-4 pb-3 mobile-content-wrapper">
  <div class="container">
    <fgb-route-nav indicatorStyle="rounded" (onTabChange)="title = $event">
      <a class="nav-item" [routerLink]="['/account']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
        <label>{{ 'account.nav.profile' | translate }}</label>
        <div class="nav-item-bg"></div>
      </a>
      <a
        class="nav-item"
        [routerLink]="['/account/activity']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'account.nav.activity' | translate }}</label>
        <div class="nav-item-bg"></div>
      </a>
    </fgb-route-nav>
  </div>
</div>

<router-outlet></router-outlet>
